import { BasicRequest } from "./basicRequest";

export class LockUserRequest extends BasicRequest{

    public userId!:number;

    constructor(){
        super();
    }
}